import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import CreateRecurringTaskModal from "~/components/tasks/CreateRecurringTaskModal/CreateRecurringTaskModal";
import { RecurringTaskContextProvider } from "./context";

const RecurringTaskProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    projectId: 0,
    taskId: 0,
    recurringTaskId: 0,
  });
  const [recurringTaskCreated, setRecurringTaskCreated] = useState(false);

  const closeModal = useCallback(() => {
    setState({
      open: false,
      projectId: 0,
      taskId: 0,
      recurringTaskId: 0,
    });
  }, []);

  const setParams = useCallback(({ open = false, projectId = 0, taskId = 0, recurringTaskId = 0 }) => {
    setState({ open, projectId, taskId, recurringTaskId });
  }, []);

  return (
    <RecurringTaskContextProvider value={{ setParams, recurringTaskCreated, setRecurringTaskCreated }}>
      {children}
      {state?.open ? (
        <CreateRecurringTaskModal
          open={state?.open}
          projectId={state?.projectId}
          onClose={closeModal}
          taskId={state?.taskId}
          recurringTaskId={state?.recurringTaskId}
        />
      ) : null}
    </RecurringTaskContextProvider>
  );
};

RecurringTaskProvider.propTypes = {
  children: PropTypes.any,
};

export default RecurringTaskProvider;
